import { render, staticRenderFns } from "./Phases.vue?vue&type=template&id=00caba1d&scoped=true&"
import script from "./Phases.vue?vue&type=script&lang=ts&"
export * from "./Phases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00caba1d",
  null
  
)

export default component.exports